import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import QuestionsPage from './QuestionsPage';
import ResultsPage from './ResultsPage';
import AdminImages from './AdminImages';
import SectionsEditor from './SectionsEditor';
import FormBuilder from './FormBuilder';

const AdminRoutes = () => {
  return (
    <Switch>
      <Redirect
        exact
        from="/admin"
        to="/admin/questions"
      />
      <Route
        path="/admin/questions"
        component={QuestionsPage}
      />
      <Route path="/admin/users" component={ResultsPage} />
      <Route
        path="/admin/secciones"
        component={SectionsEditor}
      />
      <Route
        path="/admin/formulario"
        component={FormBuilder}
      />
      <Route
        exact
        path="/admin/imagenes"
        component={AdminImages}
      />
    </Switch>
  );
};

export default AdminRoutes;
